
export default function Schedule({ appointments }) {
  return (
    <div className="flex-1 p-6 min-h-screen overflow-auto" style={{ backgroundColor: 'var(--color-background)' }}>
      <h1 className="text-2xl font-bold mb-6" style={{ color: 'var(--color-text)' }}>Today&apos;s Schedule</h1>
      <div style={{ 
        backgroundColor: 'var(--color-widgetBackground)', 
        borderRadius: '0.5rem', 
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
        overflow: 'hidden',
        border: '1px solid var(--color-widgetBorder)'
      }}>
        <table className="w-full">
          <thead>
            <tr style={{ backgroundColor: 'var(--color-widgetHeaderBackground)' }}>
              <th className="p-4 font-medium" style={{ color: 'var(--color-widgetHeaderText)' }}>Time</th>
              <th className="p-4 font-medium" style={{ color: 'var(--color-widgetHeaderText)' }}>Patient</th>
              <th className="p-4 font-medium" style={{ color: 'var(--color-widgetHeaderText)' }}>Age</th>
              <th className="p-4 font-medium" style={{ color: 'var(--color-widgetHeaderText)' }}>Reason</th>
              <th className="p-4 font-medium" style={{ color: 'var(--color-widgetHeaderText)' }}>Notes</th>
            </tr>
          </thead>
          <tbody>
            {appointments?.map((appointment) => (
              <tr 
                key={appointment.id} 
                style={{
                  borderBottom: '1px solid var(--color-widgetBorder)',
                  transition: 'background-color 0.2s',
                  ':hover': {
                    backgroundColor: 'var(--color-highlight)'
                  }
                }}
              >
                <td className="p-4" style={{ color: 'var(--color-text)' }}>{appointment.time}</td>
                <td className="p-4">
                  <div className="flex items-center space-x-3">
                    <img 
                      src={appointment.patient.image} 
                      alt={`${appointment.patient.firstName} ${appointment.patient.lastName}`} 
                      style={{
                        width: '2rem',
                        height: '2rem',
                        borderRadius: '9999px',
                        backgroundColor: 'var(--color-highlight)'
                      }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="${encodeURIComponent('var(--color-mutedText)')}"><path d="M12 4a4 4 0 014 4 4 4 0 01-4 4 4 4 0 01-4-4 4 4 0 014-4m0 10c4.42 0 8 1.79 8 4v2H4v-2c0-2.21 3.58-4 8-4z"/></svg>`;
                      }}
                    />
                    <span style={{ color: 'var(--color-text)' }}>
                      {appointment.patient.lastName}, {appointment.patient.firstName}
                    </span>
                  </div>
                </td>
                <td className="p-4" style={{ color: 'var(--color-text)' }}>{appointment.patient.age}</td>
                <td className="p-4">
                  <span 
                    style={{
                      display: 'inline-block',
                      padding: '0.25rem 0.75rem',
                      borderRadius: '9999px',
                      fontSize: '0.875rem',
                      fontWeight: '500',
                      minWidth: '100px',
                      textAlign: 'center',
                      backgroundColor: appointment.reason.includes('Follow-up')
                        ? 'var(--color-primary)'
                        : 'var(--color-accent)',
                      color: 'white'
                    }}
                  >
                    {appointment.reason}
                  </span>
                </td>
                <td className="p-4" style={{ color: 'var(--color-mutedText)' }}>{appointment.notes}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}